import { graphql } from "@/gql";

export const relocationDepartureDatesQuery = graphql(`
  query RelocationDepartureDates(
    $supplierId: ID!
    $vehicleId: ID!
    $departureOfficeId: ID!
    $deliveryOfficeId: ID!
    $hireUnitType: HireUnitType!
    $availableFromDate: String!
    $availableToDate: String!
    $fixedLatestDepartureDate: String
    $hireUnitsAllowed: Int!
    $extraHireUnitsAllowed: Int!
    $minimumHireUnits: Int!
  ) {
    relocationDepartureDates(
      supplier_id: $supplierId
      vehicle_id: $vehicleId
      departure_office_id: $departureOfficeId
      delivery_office_id: $deliveryOfficeId
      hire_unit_type: $hireUnitType
      available_from_date: $availableFromDate
      available_to_date: $availableToDate
      fixed_latest_departure_date: $fixedLatestDepartureDate
      hire_units_allowed: $hireUnitsAllowed
      extra_hire_units_allowed: $extraHireUnitsAllowed
      minimum_hire_units: $minimumHireUnits
    ) {
      departureDates {
        date
        ranges {
          end
          start
        }
      }
      earliestBookableTime
    }
  }
`);
